import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AppService } from 'src/app/_services/app.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    standalone: false
})

// Created to handle logout with allowing system to check changes before logging out
export class LogoutComponent implements OnInit {

  constructor(@Inject('BASE_URL') public baseUrl: string, private http: HttpClient, public router: Router, public service: AppService, private msalService: MsalService) { }

  ngOnInit() {
    // Check if this is an impersonation session
    if (this.service.getCookie('Imp_Token')) {
      this.logoutUser();
    } else {
      const details = this.msalService.instance.getActiveAccount();
      if (details) {
        this.msalService.instance.logoutPopup().then(e => {
          this.logoutUser();
        });
      } else {
        this.logoutUser();
      }
    }
  }


  logoutUser() {
    this.http.get(this.baseUrl + 'api/auth/logout').subscribe(result => {
      this.service.currentUser = undefined;
      const temp = new Promise((resolve, reject) => {
        this.service.CheckAuth().then(res => {
          if (res) {
            if (this.service.currentUser) {
              this.router.navigate([this.service.currentUser.defaultUrl]);
            } else {
              this.router.navigate(['login']);
            }
            resolve(true);
          } else {
            this.router.navigate(['login']);
            resolve(false);
          }
        });
      });
  }, error => {
    console.error(error);
  });
  }
}
